import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, Suspense } from "react";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { adminAuthRoutes, adminRoutes } from "./routes/adminRoutes";
import Authmiddleware from "./routes/middleware/Authmiddleware";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/theme.scss";
import { adminPrefix } from "configs/routePrefix";
import ScrollToTop from "components/Website/ScrollToTop";
import { useSelector, useDispatch } from "react-redux";
import { authenticate } from "store/Auth/actions";
import http from "services/HttpService";
import "./App.scss";
import { websiteAuthRoutes, websiteRoutes } from "routes/websiteRoutes";
import HorizontalLayout from "components/HorizontalLayout";
import NonAuthBuyerLayout from "components/NonAuthBuyerLayout";
import { SiteProvider } from "contexts/SiteContext";
import { getAuthData } from "components/Enums";
// Safe shim for browsers that don't implement requestIdleCallback (Safari).
const onIdle =
	typeof window !== "undefined" && "requestIdleCallback" in window
		? window.requestIdleCallback
		: (cb) => setTimeout(cb, 1);

const SuspenseFallback = () => null;

const App = (props) => {
	const [type, setType] = useState("");
	const dispatch = useDispatch();
	const AuthData = useSelector((state) => state.Auth);
	const sectionRef = useRef(null);

	// AOS (scroll animations) + toastify CSS are non-critical for first paint.
	// Load them after the main thread goes idle so they don't block LCP.
	useEffect(() => {
		const handle = onIdle(async () => {
			await Promise.all([
				import("aos/dist/aos.css"),
				import("react-toastify/dist/ReactToastify.css"),
			]);
			const { default: AOS } = await import("aos");
			AOS.init({
				duration: 600,
				easing: "ease-out-cubic",
				once: true,
				offset: 60,
			});
		});
		return () => {
			if (typeof window !== "undefined" && "cancelIdleCallback" in window) {
				window.cancelIdleCallback(handle);
			}
		};
	}, []);

	useEffect(() => {
		if (!!AuthData.lang) {
			localStorage.setItem("vr_lang", AuthData.lang);
			http.setLang(AuthData.lang);
			document.documentElement.dir = AuthData.lang === "ar" ? "rtl" : "ltr";
			document.documentElement.lang = AuthData.lang;
		}
	}, [AuthData.lang]);

	useEffect(() => {
		const lang = localStorage.getItem("vr_lang") || "en";
		dispatch(
			authenticate({
				lang: lang,
			}),
		);
	}, []);

	useEffect(() => {
		getAuthData(dispatch);
	}, []);

	function getLayout() {
		let layoutCls = VerticalLayout;
		switch (props.layout.layoutType) {
			case "horizontal":
				layoutCls = HorizontalLayout;
				break;
			default:
				layoutCls = VerticalLayout;
				break;
		}
		return layoutCls;
	}
	const Layout = getLayout();

	// ${AuthData.lang !== "ar" ? AuthData.lang : "ar-wrapper"}
	return (
		<SiteProvider>
			<React.Fragment>
				<div ref={sectionRef} className={`${AuthData?.lang || "en"} ${type}`}>
					<Router>
						<ScrollToTop />
						<ToastContainer />
						<Suspense fallback={<SuspenseFallback />}>
							<Switch>
								{adminAuthRoutes.map((route, idx) => (
									<Authmiddleware
										setType={setType}
										path={adminPrefix + route.path}
										routePrefix={adminPrefix}
										layout={NonAuthLayout}
										component={route.component}
										key={idx}
										panel="admin"
										isAuthProtected={false}
										exact
									/>
								))}

								{adminRoutes.map((route, idx) => (
									<Authmiddleware
										setType={setType}
										path={adminPrefix + route.path}
										routePrefix={adminPrefix}
										layout={Layout}
										component={route.component}
										key={idx}
										panel="admin"
										isAuthProtected={true}
										exact
									/>
								))}

								{websiteRoutes.map((route, idx) => (
									<Authmiddleware
										setType={setType}
										path={route.path}
										routePrefix={""}
										layout={NonAuthBuyerLayout}
										component={route.component}
										key={idx}
										panel="user"
										isAuthProtected={true}
										exact
									/>
								))}

								{websiteAuthRoutes.map((route, idx) => (
									<Authmiddleware
										setType={setType}
										path={route.path}
										routePrefix={""}
										layout={NonAuthBuyerLayout}
										component={route.component}
										key={idx}
										panel="user"
										isAuthProtected={false}
										exact
									/>
								))}
							</Switch>
						</Suspense>
					</Router>
				</div>
			</React.Fragment>
		</SiteProvider>
	);
};

App.propTypes = {
	layout: PropTypes.any,
};

const mapStateToProps = (state) => {
	return {
		layout: state.Layout,
	};
};

export default connect(mapStateToProps, null)(App);
